import React,{ Component } from 'react';
// import PropTypes from 'prop-types';
import Route from 'react-router-dom/Route';
import Switch from 'react-router-dom/Switch'

import AgencyPortal from '../../AgencyPortal';
import ProviderPortal from '../../ProviderPortal';
import OnboardingPortal from '../../OnboardingPortal';
import Login from '../../Login';
import SetPassword from '../../SetPassword';
import ForgotPassword from '../../ForgotPassword';
import GuidedCampaignCreation from '../../GuidedCampaignCreation';

import ReactGA from 'react-ga';
import PreviewCampaign from "../../PreviewCampaign";
import PhonePreviewCampaign from "../../PhonePreviewCampaign";
import PhonePreviewIFrame from "../../PhonePreviewIFrame";

import { GOOGLE_ANALYTICS_ID, ANALYTICS_ON } from '../../../config';
import {hideChatBox} from '../../../shared/utils';

const GUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

class Portal extends Component {
  componentWillMount(){
    Promise.all([
      this.props.loadAuthTokenFromCookie(),
      this.props.loadImpersonateTokenFromCookie(),
    ]);

  }

  componentDidMount(){
    this.props.loadVersion();
    console.log('location:', window.location)
    if (ANALYTICS_ON && window.location.pathname !== '/phonepreview' && window.location.pathname.indexOf('/preview/') === -1 && window.location.pathname.indexOf('/previewinternal/') === -1) {
      let driftbot_function = function() {
          console.log('executing analytics init with', GOOGLE_ANALYTICS_ID);
          var analytics=window.analytics=window.analytics||[];
          if(!analytics.initialize) if(analytics.invoked) window.console&&console.error&&console.error("Segment snippet included twice.");
          else{
            analytics.invoked=!0;
            analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];
            analytics.factory=function(t){
              return function(){
                var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);
                return analytics
              };
            };
            for(var t=0;t<analytics.methods.length;t++){
              var e=analytics.methods[t];analytics[e]=analytics.factory(e)
            }
            analytics.load=function(t,e){
              var n=document.createElement("script");
              n.type="text/javascript";
              n.async=!0;
              n.src="https://cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";
              var a=document.getElementsByTagName("script")[0];
              a.parentNode.insertBefore(n,a);
              analytics._loadOptions=e
            };
            analytics.SNIPPET_VERSION="4.1.0";
            analytics.load("4miLpfwldqJkHhtwnXW5kVBpYoTNWrdJ");
            analytics.page();
          }
      }
      driftbot_function();
    } else {
      ReactGA.initialize(GOOGLE_ANALYTICS_ID,{
	      debug:false,
	      titleCase:false,
	      gaOptions:{
	        cookieDomain:'auto'
        }
	    });

      this.trackPageView(this.props.location);
      this.unbindHistoryListener = this.props.history.listen((location) => {
        this.trackPageView(location);
      });
    }
  }

  componentWillUnmount(){
    this.unbindHistoryListener();
  }

  trackPageView(location){
    const sanitizedPathname = location.pathname.split('/').map((part) => GUID_REGEX.test(part) ? '<ID>' :part).join('/');
    ReactGA.pageview(sanitizedPathname);
  }

  render(){
    return (
      <div className='Portal'>
        <Switch>
          <Route exact path='/login'        component={Login} />
          <Route exact path='/set-password' component={SetPassword} />
          <Route exact path='/reset'        component={ForgotPassword} />
          <Route path='/account'            component={AgencyPortal} />
          <Route path='/impersonate/:email' component={AgencyPortal} />
          <Route path='/superadmin'         component={ProviderPortal} />
          <Route path='/welcome'            component={OnboardingPortal} />
          <Route path='/invite'             component={OnboardingPortal} />
          <Route path='/tutorial'           component={GuidedCampaignCreation} />
          <Route path='/preview/:previewToken' component={PhonePreviewIFrame} />
          <Route path='/previewinternal/:previewToken' component={PreviewCampaign} />
          <Route path='/phonepreview' component={PhonePreviewCampaign} />
          <Route                            component={Login} />
        </Switch>
      </div>
    )
  }
}

export default Portal;



// WEBPACK FOOTER //
// ./src/routes/Portal/components/Portal.js